import {
  Component,
  OnInit
} from '@angular/core';
import { ChangeStatusModalDirective } from '../change-status-modal.directive';
import { AuctionService, LaunchDarklyService, StatusFilter } from 'remarketing-angular-library';
import { Store } from '@ngxs/store';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';


@Component({
    selector: 'app-make-removed-modal',
    templateUrl: './make-removed-modal.component.html',
    styleUrls: ['./make-removed-modal.component.scss'],
    imports: [TranslocoDirective]
})
export class MakeRemovedModalComponent extends ChangeStatusModalDirective implements OnInit {
  textRemoveVehicles: string;
  textRemoveVehicle: string;
  textAuctionVehicles: string;
  textAuctionVehicle: string;
  textAutobidsVehicles: string;
  textAutobidsVehicle: string;

  constructor(store: Store, auctionService: AuctionService, readonly launchDarklyService: LaunchDarklyService, readonly translocoService: TranslocoService) {
    super(store, auctionService, launchDarklyService, translocoService);
  }

  ngOnInit(): void {
    this.getTranslations();
  }

  get headline() {
    if (this.selectedVehicles.length > 1) {
      return this.textRemoveVehicles;
    } else {
      return this.textRemoveVehicle;
    }
  }

  get modalBody() {
    if (this.selectedVehiclesStatus === StatusFilter.HOLD_VEHICLES) {
      if (this.selectedVehicles.length > 1) {
        return this.textAuctionVehicles;
      } else {
        return this.textAuctionVehicle;
      }
    } else if (this.selectedVehiclesStatus === StatusFilter.ACTIVE_VEHICLES) {
      if (this.selectedVehicles.length > 1) {
        return this.textAutobidsVehicles;
      } else {
        return this.textAutobidsVehicle;
      }
    }
    return '';
  }

  getTranslations() {
    super.getTranslations();
    this.translocoService
      .selectTranslateObject('sellModule.manageInventory.actionListModal.makeRemovedModal')
      .subscribe(translate => {
        this.textRemoveVehicles = translate.textRemoveVehicles;
        this.textRemoveVehicle = translate.textRemoveVehicle;
        this.textAuctionVehicles = translate.textAuctionVehicles;
        this.textAuctionVehicle = translate.textAuctionVehicle;
        this.textAutobidsVehicles = translate.textAutobidsVehicles;
        this.textAutobidsVehicle = translate.textAutobidsVehicle;
      });
  }
}
